export const dp_hero_font_family = 'TLCircular';
export const dp_hero_letter_spacing = '-0.02';
export const dp_hero_font_size = '2rem';
export const dp_hero_font_size_m = '3rem';
export const dp_hero_line_height = '2.5rem';
export const dp_hero_line_height_m = '3.5rem';
export const dp_title1_font_family = 'TLCircular';
export const dp_title1_letter_spacing = '-0.02';
export const dp_title1_font_size = '1.5rem';
export const dp_title1_font_size_m = '2rem';
export const dp_title1_line_height = '1.75rem';
export const dp_title1_line_height_m = '2.5rem';
export const dp_title2_font_family = 'TLCircular';
export const dp_title2_letter_spacing = '-0.02';
export const dp_title2_font_size = '1.25rem';
export const dp_title2_font_size_m = '1.5rem';
export const dp_title2_line_height = '1.75rem';
export const dp_title2_line_height_m = '2rem';
export const dp_title3_font_family = 'TLCircular';
export const dp_title3_letter_spacing = '-0.02';
export const dp_title3_font_size = '1.25rem';
export const dp_title3_line_height = '1.75rem';
export const dp_large_letter_spacing = '0';
export const dp_large_font_size = '1.125rem';
export const dp_large_line_height = '1.5rem';
export const dp_body_letter_spacing = '0';
export const dp_body_font_size = '1rem';
export const dp_body_line_height = '1.5rem';
export const dp_small_letter_spacing = '0';
export const dp_small_font_size = '0.9375rem';
export const dp_small_font_size_m = '0.875rem';
export const dp_small_line_height = '1.25rem';
export const dp_mini_letter_spacing = '0';
export const dp_mini_font_size = '0.875rem';
export const dp_mini_font_size_m = '0.75rem';
export const dp_mini_line_height = '1.25rem';
export const dp_mini_line_height_m = '1rem';
export const dp_micro_letter_spacing = '0';
export const dp_micro_font_size = '0.75rem';
export const dp_micro_font_size_m = '0.625rem';
export const dp_micro_line_height = '1rem';
export const dp_micro_line_height_m = '0.75rem';
